// extracted by mini-css-extract-plugin
module.exports = {"root":"SortButton_root__16Jjc","icon":"SortButton_icon__2SFfN","desc":"SortButton_desc__3OAFe","disabled":"SortButton_disabled__2z3Yn"};